import { render, staticRenderFns } from "./Scenario1point5.vue?vue&type=template&id=4beb2725"
import script from "./Scenario1point5.vue?vue&type=script&lang=js"
export * from "./Scenario1point5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports